import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { injectIntl, FormattedMessage } from 'react-intl'


class Loader extends Component {
  constructor(props) {
    super(props)
    this.data = {
      edited_data: {
        text: props.intl.formatMessage({
          id: 'aspire.loader.rescoringText',
          defaultMessage: 'Rescoring based on changes',
        }),
      },
      resume: {
        text: props.intl.formatMessage({
          id: 'aspire.loader.resumeLoadingText',
          defaultMessage: 'Resume loading',
        }),
      },
      cv: {
        text: props.intl.formatMessage({
          id: 'aspire.loader.cvLoadingText',
          defaultMessage: 'CV loading',
        }),
      },
      pdf: {
        text: props.intl.formatMessage({
          id: 'aspire.loader.fullProfileLoadingText',
          defaultMessage: 'Full profile loading',
        }),
      },
      changed_function: {
        text: props.intl.formatMessage({
          id: 'aspire.loader.newTargetFunctionLoadingText',
          defaultMessage: 'New target function loading',
        }),
      },
    }
  }
  render() {
    const {
      loaderInput,
      processedModulesCount,
      padding,
      isEditModal,
      allResumes,
      processing_resume_id,
      resumeId,
      isLeftNavExpand,
      intl,
    } = this.props

    if (!this.data.hasOwnProperty(loaderInput)) {
      return null
    }

    let percent = 0

    if (
      !_.isNull(processedModulesCount) &&
      processedModulesCount['total'] > 0
    ) {
      percent = Math.ceil(
        (processedModulesCount['processed'] / processedModulesCount['total']) *
          100
      )
    }

    let spacing = 0

    if (!_.isUndefined(padding)) {
      spacing = padding
    }

    let styles = {
      width: 'calc(100%-' + spacing + 'px',
      left: spacing + 'px',
      right: spacing + 'px',
    }

    if (loaderInput == 'resume' || loaderInput == 'cv') {
      let processingResume
      if (_.isNull(processing_resume_id)) {
        processingResume = _.findWhere(allResumes, { id: resumeId })
      } else {
        processingResume = _.findWhere(allResumes, { id: processing_resume_id })
      }
      if (!processingResume) {
        return null
      }
      return (
        <div
          className={`progress-bar-div progress-bar-div-resume loader-z-index ${
            isEditModal && 'progress-bar-div-function'
          } ${isLeftNavExpand && 'progress-bar-div-left-nav'}`}
          aria-live="polite"
        >
          <div className="edit-progress-div edit-progress-div-resume">
            <div
              className="edit-progress-stick"
              style={{ width: percent + '%' }}
            >
              <div className="resume-name-loader">
                {processingResume.filename}
              </div>
              <div className="resume-loader-text">
                <FormattedMessage
                  id="aspire.loader.resumeLoaderText"
                  defaultMessage="Resume loading"
                />
              </div>
              {percent > 0 && (
                <div className="resume-loader-percent">
                  {percent}
                  <span>%</span>
                </div>
              )}
            </div>
          </div>
          <div className="edit-progress-overlay-all edit-progress-overlay-all-resume"></div>
        </div>
      )
    }

    return (
      <div
        className={`progress-bar-div loader-z-index ${
          isEditModal && 'progress-bar-div-function'
        } ${isLeftNavExpand && 'progress-bar-div-left-nav'}`}
        aria-live="polite"
      >
        <div className="edit-progress-div-wrapper">
          <div className="edit-progress-div">
            <div className="edit-progress-top">
              <div className="edit-progress-top-text">
                <FormattedMessage
                  id="aspire.loader.pleaseWaitLinkedin"
                  defaultMessage="Please wait! Your LinkedIn profile is being processed..."
                />
              </div>
              <div className="edit-progress-top-progress">
                {percent}
                <span className="edit-progress-top-percent-symbol">%</span>
              </div>
            </div>
            <div className="edit-progress-stick">
              <div
                className="edit-progress-stick-progress"
                style={{ width: percent + '%' }}
              ></div>
            </div>
          </div>
          <div className="edit-progress-overlay-all"></div>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  let loaderInput = state.aspireFeedbackData.mini_loader_text
  if (loaderInput === 'resume') {
    loaderInput =
      state.user.data && state.user.data.isResumeCalledCv ? 'cv' : loaderInput
  }
  return {
    loaderInput,
    processedModulesCount: state.aspireFeedbackData.processed_modules_count,
    isEditModal: state.editData.show_edit_modal,
    allResumes: state.resumeHistory.data,
    processing_resume_id: state.AspireUploadResume.processing_resume_id,
    resumeId: state.aspireFeedbackData.resume_id,
    isLeftNavExpand: state.editData.isLeftNavExpand,
  }
}

export default connect(mapStateToProps, {})(injectIntl(Loader))

const UpdateLoaderPercent = (props) => {
  return (
    <div key={props.percent} className="progress-number">
      {props.percent}%{' '}
    </div>
  )
}
